import Service from "./Service";
import {
  SearchModel,
  UserOne,
  CardTypeClass,
  ChildClass,
  PassgerClass,
  SearchResult,
  TrainResult,
  SeatCode,
  TrainInfo,
  Seat,
  StationEntity,
  Stations,
  Station,
} from "@/model/TrainPolicy";
import { PageList } from "@/model/system";
class TrainPolicyService extends Service {
  getTrainLists(data: any) {
    return this.post<any>(`/TrainSearch/Search`, data);
  }
  getStationList(data: StationEntity) {
    return this.post<PageList<StationEntity>>(`/TrainSearch/Station`, data);
  }
  getProductInfo(data: any) {
    return this.post<any>(`/TrainPolicy/ProductInfo`, data);
  }
}
export default new TrainPolicyService("trainPolicy");
